export const FORM_NAME = 'registration'
